import React from "react";
import { withRouter } from "react-router-dom";
import ProfileService from "../../services/profileService";
import { getUserBalance } from "../../global/getUserBalance";
import { app_path } from "config";
import PaymentPreview from "./PaymentPreview";

var downloadTimer;

class RazorpayPaymentStatus extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      status: this.props.match.params.id,
      error: false,
      timer: "",
      redirect: true,
      redirectPath: "",
      order_id: "",
    };
  }

  componentDidMount() {
    const { updateUserBalance } = this.props;
    const response = this.props.history.location.state
      ? JSON.parse(this.props.history.location.state)
      : "";
    const company_recharge = response && response.company_recharge;
    this.setState({
      redirectPath: response && response.redirectPath,
      order_id: response && response.order_id,
      origin: response && response.origin,
      status: response && response.status,
      amount: response && response.amount,
      netPayableAmount: response && response.netPayableAmount,
      finaTotal: response && response.finaTotal,
      company_recharge,
      rechargeFailReason:
        response && response.rechargeFailReason
          ? response.rechargeFailReason
          : null,
    });
    if (response && response.origin == "plumPro") {
      this.plumProPoints();
    } else {
      getUserBalance(updateUserBalance);
    }
    this.successRedirect(company_recharge);
  }

  plumProPoints = () => {
    const { updatePlumProPoints } = this.props;

    ProfileService.plumProPoints({})
      .then((response) => {
        if (
          response &&
          response.cashReserveBalance &&
          response.cashReserveBalance.status == true
        ) {
          let data = response.cashReserveBalance.data.balance;

          updatePlumProPoints(data);
        }
      })
      .catch(() => {});
  };

  getBalanceToShow = (company_recharge) => {
    const {
      accountReducer: {
        userBalance: { userBalance = 0, companyBalance = 0 } = {},
        plumProPoints: { balance = 0 } = {},
        typeData: { walletCompany = 0 } = {},
      } = {},
    } = this.props;
    let balanceToShow = 0;
    if (this.state.origin === "plumPro") {
      if (walletCompany) {
        balanceToShow = userBalance;
      } else {
        balanceToShow = balance;
      }
    } else {
      if (company_recharge === 1) {
        balanceToShow = companyBalance;
      } else {
        balanceToShow = userBalance;
      }
    }

    return balanceToShow;
  };

  successRedirect = (company_recharge) => {
    //if (this.state.error === false && this.state.status == "success") {
    //this.getUserBalance()
    var timeleft = 3;
    downloadTimer = setInterval(
      function () {
        timeleft--;
        this.setState({ timer: timeleft });

        if (timeleft <= 0 && this.state.redirect) {
          clearInterval(downloadTimer);
          this.props.history.push({
            pathname: this.state.redirectPath || `/${app_path}/recharge/`,
            state: JSON.stringify({
              paymentStatus: this.state.status,
              company_recharge: company_recharge,
              amount: this.state.amount,
              finaTotal: this.state.finaTotal,
              userBalance: this.getBalanceToShow(company_recharge),
            }),
          });
        }
      }.bind(this),
      1000
    );
    //}
  };
  redirectToAdmin = () => {
    const { company_recharge, finaTotal } = this.state;
    clearInterval(downloadTimer);
    this.props.history.push({
      pathname: this.state.redirectPath || `/${app_path}/recharge/`,
      state: JSON.stringify({
        paymentStatus: this.state.status,
        amount: this.state.amount,
        finaTotal: finaTotal,
        userBalance: this.getBalanceToShow(company_recharge),
        company_recharge,
        rechargeFailReason:
          this.state.status == "fail" ? this.state.rechargeFailReason : null,
      }),
    });

    this.setState({ redirect: false });
  };

  render() {
    const { status, rechargeFailReason } = this.state;
    const redirectPathObj = this.props.history.location.state
      ? JSON.parse(this.props.history.location.state)
      : {};
    const redirectPath = redirectPathObj?.redirectPath || "";
    // const rzpContainer = document.querySelector(".razorpay-container");
    // rzpContainer?.remove();

    return (
      <PaymentPreview
        status={status}
        seconds={this.state.timer}
        rechargeFailReason={rechargeFailReason}
        redirectHandler={() => {
          this.redirectToAdmin(
            redirectPath && redirectPath.callbackPath
              ? redirectPath.callbackPath
              : ""
          );
        }}
      />
    );
  }
}
export default withRouter(RazorpayPaymentStatus);
